import React from 'react';
import { CtaButtonType } from '@tcs/create-account/utils/prismic/types';
import { useStyles } from './style';
import { Button } from '@forgeglobal/design-framework';

interface CtaButtonProps {
  data: CtaButtonType;
}

const CtaButton: React.FC<CtaButtonProps> = ({ data }) => {
  const classes = useStyles();
  const { cta, link } = data;

  return (
    <section className={classes.wrapper}>
      <Button href={link.url}>{cta}</Button>
    </section>
  );
};

export default CtaButton;
